const STRONG_REASONS = new Set([
    "phone_exact",
    "email_exact",
    "full_name",
    "email_on_candidate",
    "staff_confirmed",
]);

const TOKEN_SKIP = new Set(["and", "the", "jr", "sr", "ii", "iii", "iv"]);

export const MATCH_REASON_LABELS = {
    phone_exact: "Exact phone",
    email_exact: "Exact email",
    full_name: "Full name",
    email_on_candidate: "Email on the client record",
    suggested_last_name: "Last name only",
    email_local_conflict: "Email name disagrees with this client",
    pet_conflict: "Message names a different pet",
    search_truncated: "Too many name matches to link automatically",
    ambiguous: "More than one client matched",
    no_candidates: "No name match",
    no_last_name: "No usable last name",
    staff_confirmed: "Confirmed by staff",
    staff_unlinked: "Unlinked by staff",
    suggestion_dismissed: "Suggestion dismissed",
    lookup_error: "Lookup failed",
};

export function matchReasonLabel(reason) {
    if (!reason) return "";
    return MATCH_REASON_LABELS[reason] || String(reason).replace(/_/g, " ");
}

export function personTokens(value) {
    if (!value) return [];
    return String(value)
        .replace(/\([^)]*\)/g, " ")
        .toLowerCase()
        .replace(/['’.]/g, "")
        .split(/[^a-z0-9]+/)
        .filter((token) => token && !TOKEN_SKIP.has(token));
}

export function senderLabel(chain) {
    if (!chain) return "";
    if (chain.sender_name) return chain.sender_name;
    const nameEntry = (chain.client_lookup_log || []).find((entry) => entry.type === "name" && entry.value);
    return nameEntry?.value || "";
}

export function isWeakNameLink(chain) {
    if (!chain?.client_id) return false;
    if (STRONG_REASONS.has(chain.client_match_reason)) return false;
    const nameHit = (chain.client_lookup_log || []).find((entry) => entry.type === "name" && entry.matched);
    if (!nameHit) return false;
    if (nameHit.reason && STRONG_REASONS.has(nameHit.reason)) return false;
    const sender = personTokens(chain.sender_name || nameHit.value);
    const linked = personTokens(chain.client_name);
    if (sender.length < 2 || linked.length < 2) return true;
    return sender[0] !== linked[0];
}
